var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 552.41 552.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:40px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M457.37,95A256.21,256.21,0,0,0,95,457.37,256.21,256.21,0,0,0,457.37,95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.05,376.44a8.24,8.24,0,0,0-8.94,3.51c-10.25,15.1-26,20.2-34.77,16.25-6.83-3.08-6.45-10.71-4.93-16.57L318.3,230.38a.7.7,0,0,1,0-.14c.05-.23.1-.47.13-.7a2.34,2.34,0,0,0,0-.26c0-.23,0-.46.05-.69s0-.17,0-.25c0-.27,0-.55,0-.83a.28.28,0,0,1,0-.09v0a8.91,8.91,0,0,0-.16-.9,1.21,1.21,0,0,0-.05-.18c-.06-.24-.13-.47-.21-.71l-.09-.22a5.17,5.17,0,0,0-.28-.64l-.1-.21a7.16,7.16,0,0,0-.39-.66l-.09-.14a8.23,8.23,0,0,0-.57-.75h0l-.05,0c-.18-.2-.38-.4-.58-.59l-.19-.17-.54-.42-.2-.15c-.23-.15-.46-.3-.71-.43l-.06,0c-.28-.14-.57-.27-.86-.39l-.09,0c-.25-.09-.51-.18-.78-.25l-.21-.05c-.23,0-.46-.1-.7-.13l-.24,0c-.24,0-.48,0-.72-.05h-.22c-.3,0-.61,0-.92.05L222.23,230.3a8.34,8.34,0,0,0-7.49,8.45,8.13,8.13,0,0,0,8.12,7.81,7.5,7.5,0,0,0,.94-.05l14.85-1.71A9.51,9.51,0,0,1,249,256.65L216.46,381.38c-3.92,15-3.65,28.07.8,38.81a38,38,0,0,0,22.83,21.63,48.83,48.83,0,0,0,16.61,2.78c10.71,0,22.23-3.08,33.3-9.07,18.19-9.84,33.59-26.8,43.36-47.77A8.16,8.16,0,0,0,328.05,376.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.35,186.47A39.33,39.33,0,1,0,260,147.13,39.39,39.39,0,0,0,299.35,186.47Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e47eb655dd7effc861de712ae9642acc.svg";
export { ForwardRef as ReactComponent };